import { PageType } from 'modules/common/types'
import { PageDefenseEnum, PathEnum } from 'modules/common/enums'
import { RoleEnum } from 'modules/auth/enums'
import { SendPush } from './SendPush'
import { NotificationTemplateEditor } from './TemplateEditor'

export const pages: PageType[] = [
	{
		path: PathEnum.PUSH_NOTIFICATIONS,
		component: SendPush,
		pageDefense: PageDefenseEnum.AUTH,
		rolesAllowed: [RoleEnum.ADMIN],
	},
	{
		path: PathEnum.TEMPLATES_EDITOR,
		component: NotificationTemplateEditor,
		pageDefense: PageDefenseEnum.AUTH,
		rolesAllowed: [RoleEnum.ADMIN],
	},
]
